import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RfMonthlyLimitPageUI from './RfMonthlyLimitPageUI'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'

class RfMonthlyLimitPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      monthlyAccountSummaryList: null,
      monthlyLimitAdded: false,
      deleteSubmitted: false
    }
  }

  render() {
    return (
      <RfMonthlyLimitPageUI
        context={this.props.context}
        account={this.state.account}
        monthlyAccountSummaryList={this.state.monthlyAccountSummaryList}
        onRefreshClick={this.onRefreshClick}
        //
        monthlyLimitAdded={this.state.monthlyLimitAdded}
        onAddMonthlyLimitClick={() => { this.setState({ monthlyLimitAdded: true }) }}
        onAddMonthlyLimitCancel={() => { this.setState({ monthlyLimitAdded: false }) }}
        //
        deleteSubmitted={this.state.deleteSubmitted}
        onDeleteMonthlyLimitClick={this.onDeleteMonthlyLimitClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getMonthlySummaries(context)
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Account(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  getMonthlySummaries(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/monthly/summaries`,
      cacheKey: CacheKeys.MonthlySummaries(this.props.match.params.accountId),
      callback: this.getMonthlySummariesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getMonthlySummariesCallback = (response) => {
    this.setState({
      monthlyAccountSummaryList: response.monthlyAccountSummaryList,
    })
  }

  onDeleteMonthlyLimitClick = (event) => {
    if (this.state.deleteSubmitted)
      return

    let yearMonth = event.currentTarget.getAttribute('data-year-month')
    this.setState({ deleteSubmitted: true })
    RestApiUtils.delete(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/monthly/${yearMonth}/summaries`,
      this.onDeleteMonthlyLimitClickCallback, null, null
    )
  }

  onDeleteMonthlyLimitClickCallback = response => {
    this.setState({ deleteSubmitted: false })

    if (response.errorList.length === 0) {
      this.onRefreshClick()
    }
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.MonthlySummaries(this.props.match.params.accountId))
    this.setState({ monthlyAccountSummaryList: null },
      () => {
        this.getMonthlySummaries(context)
      }
    )
  }

}

export default withRouter(RfMonthlyLimitPageSF)
